/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Max_Docenten_ReachedInputs */

const nl_invite_errors_max_docenten_reached = /** @type {(inputs: Invite_Errors_Max_Docenten_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het maximum aantal docenten voor deze school is bereikt`)
};

/**

* @param {Invite_Errors_Max_Docenten_ReachedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_max_docenten_reached = /** @type {((inputs?: Invite_Errors_Max_Docenten_ReachedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Max_Docenten_ReachedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_max_docenten_reached(inputs)
});
export { invite_errors_max_docenten_reached as "invite.errors.max_docenten_reached" }